import React from 'react';
import { OnboardingClasses } from '../onboarding.enums';
import { OnboardingStep } from '../onboarding.types';

export const ROUTE_ITEM_TOUR: OnboardingStep[] = [
    {
        className: OnboardingClasses.FIRST_ROUTE_NAME,
        title: 'Route Name',
        placement: 'right',
        borderRadius: 4,
        content: (
            <>
                The first stop of the route is the <b>beginning of the route</b>
                .
                <br />
                Name it something meaningful and easily identifiable, like
                address or a restaurant name, etc..
            </>
        ),
    },
    {
        className: OnboardingClasses.FIRST_ROUTE_ROUND_TRIP,
        title: 'Round Trip',
        placement: 'right',
        borderRadius: 18,
        content: (
            <>
                By tapping the &quot;Round Trip&quot; icon, you will let
                Travelity know that the route is a round trip.
                <br />
                That does not mean that there are no intermediate stops, it only
                means that the beginning and the end of the route are the same
            </>
        ),
    },
    {
        className: OnboardingClasses.FIRST_ROUTE_ARRIVAL,
        title: 'Arrival Offset',
        placement: 'right',
        borderRadius: 4,
        padding: 6,
        content: (
            <>
                Arrival offset indicates how many days, hours and minutes{' '}
                <b>after the start of the tour</b> will your customers reach the
                given location. <br />
                For the start location, we can leave it unset, as the tour
                starts at the beginning of the route
            </>
        ),
    },
    {
        className: OnboardingClasses.FIRST_ROUTE_DURATION,
        title: 'Stop Duration',
        placement: 'right',
        borderRadius: 4,
        padding: 6,
        content: `
                Stop duration indicates how long will your customers be in the given location, before the tour proceeds
            `,
    },
    {
        className: OnboardingClasses.FIRST_ROUTE_ACTIONS,
        title: '',
        placement: 'right',
        borderRadius: 20,
        content: `
                Use the checkmark to finish editing the stop's details or X to discard them
            `,
    },
    {
        className: OnboardingClasses.ROUTE_CARDS,
        title: 'Route Card',
        placement: 'right',
        borderRadius: 24,
        content: (
            <>
                You can add as many stops as you need for your product.
                <br />
                Keep in mind that if the route is not a round trip, you are
                required to add both the beginning and end locations.
            </>
        ),
    },
];
